const keys = {};

export const ProjectStatusKeys = {
  CANCELLED: 'cancelled',
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETE: 'complete',
  LOST: 'lost',
  PRECON: 'precon',
};

export class ProjectStatusEnum {
  constructor(status, label) {
    this.status = status;
    this.label = label;

    keys[status] = this;
  }

  static create(status) {
    if (keys[status]) {
      return keys[status];
    }

    return ProjectStatusEnum.UNKNOWN;
  }

  equals(projectStatusEnum) {
    return this.status === projectStatusEnum.status;
  }
}

ProjectStatusEnum.PENDING = new ProjectStatusEnum('pending', 'Bid/Budget');
ProjectStatusEnum.IN_PROGRESS = new ProjectStatusEnum(
  'in_progress',
  'in progress'
);
ProjectStatusEnum.COMPLETE = new ProjectStatusEnum('complete', 'complete');
ProjectStatusEnum.LOST = new ProjectStatusEnum('lost', 'lost');
ProjectStatusEnum.CANCELLED = new ProjectStatusEnum('cancelled', 'cancelled');
ProjectStatusEnum.PRECON = new ProjectStatusEnum('precon', 'precon');



// WEBPACK FOOTER //
// ./src/domain/project-status-enum.js